module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("debounce")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("请注意了解 "), _c('code', [_vm._v("debounce")]), _vm._v(" 和 "), _c('code', [_vm._v("throttle")]), _vm._v(" 的区别。如果尚不清楚，请"), _c('code', [_vm._v("google")]), _vm._v("之。")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { debounce } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\ndebounce(func, [wait="), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("], [options={}])\n")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://lodash.com/docs/#debounce"
    }
  }, [_vm._v("详细文档")])]), _vm._v(" "), _c('h2', [_vm._v("throttle")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { throttle } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nthrottle(func, [wait="), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("], [options={}])\n")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://lodash.com/docs/#throttle"
    }
  }, [_vm._v("详细文档")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3eeab312", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-3eeab312"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/debounce-throttle-185.vue
// module id = 2659
// module chunks = 567